import React from "react";

import { Layout, LoadingPanel } from "..";

const Intro = () => {
  const headerProps = {
    children: <React.Fragment />,
  };

  return (
    <Layout headerProps={headerProps}>
      <LoadingPanel isOpen backdropInvisible />
    </Layout>
  );
};

export default Intro;
